import { TooltipButton } from '@bestseller-bit/frontend-community.components.tooltip-button';
import { styled } from '@mui/material/styles';

export const StyledActionButton = styled(TooltipButton)`
  height: 100%;
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.palette.info.main};
`;
